import { render, staticRenderFns } from "./bottom-adv.vue?vue&type=template&id=91e6f624&scoped=true"
import script from "./bottom-adv.vue?vue&type=script&lang=js"
export * from "./bottom-adv.vue?vue&type=script&lang=js"
import style0 from "./bottom-adv.vue?vue&type=style&index=0&id=91e6f624&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e6f624",
  null
  
)

export default component.exports